const AvatarUpload = (props) => {
  return (
    <div className="file-upload">
      <div className="image-upload-wrap">
        <input
          className="file-upload-input"
          type="file"
          onChange={props.avatarChange}
          accept="image/*"
        />
        <div className="drag-text">
          <h3>Arraste e solte a imagem para alterar o avatar</h3>
        </div>
      </div>
    </div>
  );
};

export default AvatarUpload;
